/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const Header = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: token('space.200'),
  justifyContent: 'space-between',
});

export const BetaLozenge = styled.div({
  display: 'flex',
  marginLeft: '3px',
});

export const ThingsToKnowHeader = styled.h2({
  font: token('font.heading.small'),
  marginTop: token('space.300'),
});
